export default "__VITE_ASSET__Do0g1Ej$__"